'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ConflictScoreIcon = ({ sx, score }) => {
  let color = 'red'

  switch (score) {
    case 1:
      color = '#DE6A1E'
      break
    case 2:
      color = '#C35309'
      break
    case 3:
      color = '#D43D4D'
      break
    case 4:
      color = '#C33241'
      break
  }

  return (
    <SvgIcon sx={sx} data-testid="ConflictScoreIcon">
      <svg width="56" height="14" viewBox="0 0 56 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_303_11762)">
          <rect width="14" height="14" fill={score >= 1 ? color : '#D8DCE5'} stroke="#F5F6F8" />
          <rect x="14" width="14" height="14" fill={score >= 2 ? color : '#D8DCE5'} stroke="#F5F6F8" />
          <rect x="28" width="14" height="14" fill={score >= 3 ? color : '#D8DCE5'} stroke="#F5F6F8" />
          <rect x="42" width="14" height="14" fill={score === 4 ? color : '#D8DCE5'} stroke="#F5F6F8" />
        </g>
        <rect x="0.5" y="0.5" width="55" height="13" rx="6.5" stroke="#F5F6F8" />
        <defs>
          <clipPath id="clip0_303_11762">
            <rect width="56" height="14" rx="7" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

ConflictScoreIcon.propTypes = {
  sx: PropTypes.object,
  score: PropTypes.number
}
